/**
 * Share links (`/ask/<code>`): the code in the address is the only key, and the
 * page lists people's names, so nothing on these pages goes to analytics.
 */
export function isPrivateLinkPath(pathname: string): boolean {
  return pathname.startsWith('/ask/');
}
